import React, { useState } from 'react';
import { useLanguage, AVAILABLE_LANGUAGES, Language } from '../hooks/useLanguage';

export const LanguageSelector: React.FC = () => {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const currentLanguage = AVAILABLE_LANGUAGES.find(lang => lang.code === language);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 text-ghost-400 hover:text-ghost-600 transition-colors duration-200 p-1 rounded-md hover:bg-ghost-100"
        aria-label="Selecionar idioma"
      >
        <span className="text-sm">{currentLanguage?.flag}</span>
        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-36 bg-white rounded-lg shadow-lg border border-ghost-200 py-1 z-20">
            {AVAILABLE_LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                onClick={() => {
                  changeLanguage(lang.code);
                  setIsOpen(false);
                }}
                className={`w-full px-3 py-2 text-left text-sm hover:bg-ghost-50 transition-colors flex items-center space-x-2 ${
                  language === lang.code ? 'text-blue-600 bg-blue-50' : 'text-ghost-700'
                }`}
              >
                <span>{lang.flag}</span>
                <span>{lang.name}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};